import Typography from "@mui/material/Typography"

import FastForwardIcon from '@mui/icons-material/FastForward';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import { FC } from "react";
import { Select, MenuItem } from "@mui/material";

export default function Paginator({ pageNumber, pageSize, itemsCount, itemType, setPageNumber, setPageSize }){
    return(
        <Typography>
            { pageNumber * pageSize + 1 } - { (pageNumber + 1) * pageSize} of { itemsCount } { itemType }
            <FastRewindIcon onClick={() => { if(pageNumber > 0) { setPageNumber(pageNumber - 1)}}}>-10</FastRewindIcon>
            <FastForwardIcon onClick={() => { setPageNumber(pageNumber + 1)}}>+10</FastForwardIcon>
            <Select value={pageSize} onChange={(event) => { setPageSize(event?.target.value) }} >
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
            </Select>
        </Typography>
    )
}

